import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M5 10c0 .75-.5 1.25-1.25 1.25S2.5 10.75 2.5 10 3 8.75 3.75 8.75 5 9.25 5 10zm12.5-1.25h-9C8 7.25 6.625 6.25 5 6.25c-2.125 0-3.75 1.625-3.75 3.75S2.875 13.75 5 13.75c1.625 0 3-1 3.5-2.5H10l1.25 1.25 1.25-1.25 1.25 1.25L15 11.25l1.25 1.25 2.5-2.5-1.25-1.25z',
  ],
  height: 20,
  width: 20,
});
